<router-outlet>
  <ngx-spinner bdColor="#c2c2c260" size="large" color="#ffffff" type="ball-pulse"></ngx-spinner>
</router-outlet>